import { ProfilePageLayout } from '@modules/_shared/components/ProfilePageLayout';
import { useLocale } from '@shared/hooks/locale';

export const ClaimAgency = () => {
  const { t } = useLocale();
  return (
    <ProfilePageLayout
      intent="claim"
      target="agency"
      title={t('Homeowners already see your agency on RealAdvisor')}
      description={t(
        'Claim your agency for free. Decide what homeowners see, and turn that visibility into success for your whole team.',
      )}
    />
  );
};
